export default "__VITE_ASSET__FPZv9LPX__"